import _ from 'lodash';
import config from 'application-config';
import { IS_DEVEL } from 'utils/environment';

const domains = {
	FRONTEND_ADMIN: 'frontend.admin',
	FRONTEND_CLIENT: 'frontend.client',
	BACKEND_ADMIN: 'backend.admin',
	BACKEND_CLIENT: 'backend.client',
};

/**
 * UrlHelper class to help get resource url for our application
 * Singleton
 */
class UrlHelper {
	/**
	 * Create UrlHelper instance
	 *
	 * @param configParam {Object} url configuration
	 * @return UrlHelper {Object} instance
	 */
	constructor(configParam = {}) {
		// @ts-expect-error ts-migrate FIXME
		this.config = configParam;

		// @ts-expect-error ts-migrate FIXME
		this.DOMAINS = {
			FRONTEND_ADMIN: domains.FRONTEND_ADMIN,
			FRONTEND_CLIENT: domains.FRONTEND_CLIENT,
			BACKEND_ADMIN: domains.BACKEND_ADMIN,
			BACKEND_CLIENT: domains.BACKEND_CLIENT,
		};
	}

	/**
	 * Get backend host url
	 * @return {string}  admin host url
	 */
	get clientBackend() {
		// @ts-expect-error ts-migrate FIXME
		return this.config.api.client_backend;
	}

	/**
	 * Get admin host url
	 * @return {string}  admin host url
	 */
	get adminBackend() {
		// @ts-expect-error ts-migrate FIXME
		return this.config.api.admin_backend;
	}

	/**
	 * Get client host url
	 * @return {string}  client host url
	 */
	get client() {
		return this.getDomain(domains.FRONTEND_CLIENT);
	}

	/**
	 * Get admin host url
	 * @return {string}  admin host url
	 */
	get admin() {
		// @ts-expect-error ts-migrate FIXME
		return _.get(this.config.domains, domains.FRONTEND_ADMIN);
	}

	/**
	 * @param {string} domain
	 * @example getDomain('FRONTEND_ADMIN')
	 * @return {object} domain map
	 */
	getDomain(domain) {
		const domainProps = _.get(config.domains, domain);
		return domainProps.port ? `${domainProps.hostname}:${domainProps.port}` : domainProps.hostname;
	}

	/**
	 * Get file hosting url
	 * @return {string}  file hosting url
	 */
	get fileHosting() {
		// @ts-expect-error ts-migrate FIXME
		return this.config.fileHosting;
	}

	get TOS_URL() {
		// eslint-disable-next-line
		const TOS_FILENAME = 'tos.pdf';

		return `//${this.fileHosting.cloudfront}/tos/${TOS_FILENAME}`;
	}

	/**
	 * Get url of published story
	 */
	getPublishedUrl(clientStoryId: string, cardId?: string) {
		const params = cardId ? `?cardId=${cardId}` : '';

		if (IS_DEVEL) {
			// eslint-disable-next-line max-len
			return `https://story-published-assets-production.s3-eu-west-1.amazonaws.com/${clientStoryId}/index.html${params}`;
		}
		return `https://${this.getDomain(domains.FRONTEND_CLIENT)}/${clientStoryId}/${params}`;
	}
}

export default new UrlHelper(config);
